<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import ModalDialog from "@kontextwerk/web-sdk/ui/overlay/ModalDialog.svelte"
  import {
    CONFIRMATION_EMAIL_OPTIONS,
    type ConfirmationEmailChoice,
  } from "../../_logic/confirmation-email-choice"

  type Props = {
    pending?: boolean
    error?: string | null
    onConfirm: (options: { sendConfirmationEmail: boolean }) => void | Promise<void>
    onClose: () => void
  }

  const { pending = false, error = null, onConfirm, onClose }: Props = $props()

  let emailChoice = $state<ConfirmationEmailChoice>("send")

  const submit = () => {
    if (pending) return

    void onConfirm({
      sendConfirmationEmail: emailChoice === "send",
    })
  }
</script>

<ModalDialog appearance="plain" title="Termin bestätigen" size="large" {onClose}>
  <div class="confirm-dialog-form form">
    <Input
      surfaceTone="light"
      brightBackground={true}
      type="select"
      label="Terminbestätigung"
      options={CONFIRMATION_EMAIL_OPTIONS}
      bind:value={emailChoice}
      disabled={pending}
    />
    {#if error}
      <p class="dialog-error" role="alert">{error}</p>
    {/if}
  </div>
  {#snippet footerSnippet()}
    <div class="dialog-actions">
      <CTA
        darkMode={false}
        type="primaryButton"
        content={pending ? "Wird bestätigt..." : "Termin bestätigen"}
        disabled={pending}
        onClick={submit}
      />
    </div>
  {/snippet}
</ModalDialog>

<style>
  .confirm-dialog-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    color: var(--text-invers-100, #2f4858);
  }

  :global(.confirm-dialog-form label) {
    height: auto !important;
    max-height: none !important;
    min-height: 60px;
    min-width: 0;
  }

  :global(.confirm-dialog-form .svelte-select),
  :global(.confirm-dialog-form .value-container),
  :global(.confirm-dialog-form .selected-item),
  :global(.confirm-dialog-form .select-selection),
  :global(.confirm-dialog-form .select-selection__label) {
    white-space: normal !important;
    overflow-wrap: anywhere;
    height: auto !important;
  }

  .dialog-error {
    margin: 0;
    color: var(--error-100, #c53030) !important;
    font-weight: 700;
    overflow-wrap: anywhere;
  }

  .dialog-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.6rem;
    width: 100%;
  }
</style>

